var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","tag":"section"}},[(_vm.showOptIn)?_c('p',{staticClass:"caption",domProps:{"innerHTML":_vm._s(
      _vm.isMemberGenerated ? _vm.$t('action.gdprTermsMGP', _vm.locale) : _vm.$t('action.gdprTerms', _vm.locale)
    )}}):_c('p',{staticClass:"caption"},[_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.isMemberGenerated
          ? _vm.$t('action.nonGdprTermsMGP', _vm.locale)
          : _vm.$t('action.nonGdprTerms', _vm.locale)
      )}})])])}
var staticRenderFns = []

export { render, staticRenderFns }